import React, { useState } from 'react'
import navigate from 'utils/navigate'
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  SwipeableDrawer,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { identity } from 'lodash'

import useMenuLinks from 'ui/header/useMenuLinks'
import useLogEvent from 'amplitude/useLogEvent'
import useCurrentUser from 'auth/useCurrentUser'

export const handleClick = ({ path, onClose, onClick }) => () => {
  onClose && onClose()
  onClick && onClick()
  path && navigate(path)
}

const MenuButton = ({ name, path, onClose, onClick }) => (
  <ListItem onClick={handleClick({ path, onClose, onClick })} button>
    <ListItemText>{name}</ListItemText>
  </ListItem>
)

export const MenuItem = ({ name, onClose, last, path, links, ...props }) => {
  const hasSubmenu = !!links
  return (
    <React.Fragment>
      {hasSubmenu ? (
        <List subheader={<ListSubheader disableSticky>{name}</ListSubheader>}>
          {links.map(item => (
            <MenuButton key={item.name} onClose={onClose} {...item} />
          ))}
        </List>
      ) : (
        <MenuButton onClose={onClose} name={name} path={path} {...props} />
      )}
      {last || <Divider />}
    </React.Fragment>
  )
}

export const toggleDrawer = (nextOpen, setOpen, cb = identity) => () => {
  nextOpen && cb()
  setOpen(nextOpen)
}

const MobileMenu = () => {
  const [open, setOpen] = useState(false)
  const menuLinks = useMenuLinks()

  const [{ currentUser }] = useCurrentUser({ cache: true })
  const logEvent = useLogEvent()

  const registerEvent = () => {
    currentUser && logEvent('Click Account Menu')
  }

  return (
    <React.Fragment>
      <IconButton
        onClick={toggleDrawer(true, setOpen, registerEvent)}
        color="inherit"
        aria-label="Menu"
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor="right"
        open={open}
        onClose={toggleDrawer(false, setOpen)}
        onOpen={toggleDrawer(true, setOpen, registerEvent)}
      >
        <List css={{ minWidth: '80vw' }}>
          {menuLinks.map((item, index) => (
            <MenuItem
              key={item.name}
              onClose={toggleDrawer(false, setOpen)}
              last={index >= menuLinks.length - 1}
              {...item}
            />
          ))}
        </List>
      </SwipeableDrawer>
    </React.Fragment>
  )
}

export default MobileMenu
